import { HtmlRenderer } from '../HtmlRenderer/HtmlRenderer';
import { htmlFromMarkdown } from '../PromptBodyEditor/helper/markdown';

export const PromptMarkdownRenderer = ({ markdown }: { markdown: string }) => {
  const html = htmlFromMarkdown(markdown);

  return <HtmlRenderer dangerouslySetInnerHTML={{ __html: html }} />;
};
